import React, { useEffect, useState, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal.jsx";
import TextInput from "common/TextInput";
import PasswordInput from "common/PasswordInput";
import Request from "common/Request";
import { parseSystemSecurity } from "common/api";

const Constraints = ({ passwordMinLength }) =>
  passwordMinLength === undefined ? null : (
    <small>
      New passwords must have at least {passwordMinLength} characters, not be
      very simplistic, and have at least a digit, a capital letter, a lower case
      letter, and a special character.`
    </small>
  );

const Username = ({ value }) => (
  <TextInput
    type="text"
    name="username"
    label="Username"
    className="input-control"
    icon="person"
    value={value}
    readOnly={true}
  />
);

const AskPassword = ({ name = "password", label = "Password" }) => (
  <PasswordInput
    type="text"
    name={name}
    label={label}
    className="input-control"
    icon="lock"
    defaultHidden={true}
  />
);

const invalid = (reason) => {
  throw reason;
};

const validateWith =
  ({ passwordMinLength }) =>
  ({ password, confirmation = "", ...rest }) =>
    console.warn(passwordMinLength) || password.length === 0
      ? invalid("empty password is invalid")
      : password.length < passwordMinLength
      ? invalid(`Passwords must have ${passwordMinLength} or more characters`)
      : password !== confirmation
      ? invalid("User passwords do not match")
      : { password, ...rest };

const checkErrOnSecondLineWith =
  ({ passwordMinLength }) =>
  (response) =>
    console.warn("checkErrOnSecondLineWith", response) ||
    response.match(/%ERR:/) !== null
      ? invalid(
          `Passwords must have ${passwordMinLength} or more characters and include at least one lowercase letter, one uppercase letter, one digit and one special character. Password cannot be equal to the user name, or be a common dictionary word.\n${response}`
        )
      : response;

const composeCommand = ({ username, password }) =>
  `system users passwd "${username}" force "${password}"`;

const ChangePasswordModal = (constraints) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const [username, setUsername] = useState(null);
  const actions = useContext(ActionsContext);

  const whenDone = () => actions.send("do-load");

  const doOpen = () => {
    setOpen(true);
  };
  const doClose = () => {
    setOpen(false);
  };
  const doApply = (settings) =>
    Promise.resolve(settings)
      .then(validateWith(constraints))
      .then((settings) => ifCl.run(composeCommand(settings)))
      .then(checkErrOnSecondLineWith(constraints))
      .then(whenDone)
      .then(doClose)
      .catch(setError);

  useEffect(
    () =>
      actions.recv(
        `change-password`,
        ({ user }) => (setUsername(user), doOpen())
      ),
    []
  );
  return open !== true ? null : (
    <Modal
      title="Change User Password"
      superIcon="pencil"
      onApply={doApply}
      onClose={doClose}
      closeLabel="CANCEL"
      content={() => (
        <>
          <Constraints {...constraints} />
          <Username value={username} />
          <AskPassword />
          <AskPassword name="confirmation" label="Confirm Password" />
        </>
      )}
      footerMessage={
        (error !== null && (
          <span className="modal-err-msg color-red align-left">
            {String(error)}
          </span>
        )) ||
        null
      }
    />
  );
};

const loadContraints = () =>
  ifCl.run("show system security").then(parseSystemSecurity);

const ChangePasswordModalUnderConstrains = () => {
  const [load, setLoad] = useState(null);
  const doLoad = () => setLoad(loadContraints());
  useEffect(() => doLoad(), []);
  return load === null ? null : (
    <Request during={loadContraints()}>
      {(settings) => <ChangePasswordModal {...settings} />}
    </Request>
  );
};

export default ChangePasswordModalUnderConstrains;
